<template>
  <div class="trOrderDetail linear-main3">
    <ld-header
      @click-left="back"
      transparent
      white
    >
      <span class="font12">{{ $t('F001','订单号') }}：{{ detail.orderNo }}  &nbsp;{{ detail.tripTypeStr }}</span>
    </ld-header>

    <div class="trOrderDetailWrapper">
      <mescroll-vue
        :down="down"
      >
        <van-pull-refresh
          v-model="isLoading"
          @refresh="getDetail"
        >
          <div>
            <div class="white pad8">
              <div class="font-lg font24 mt5 fontTitle">
                <span>{{ detail.orderStatusDesc }}</span>
                <ld-email-popup
                  v-if="id"
                  :id="id"
                  :djlx="11009"
                  :order-no="detail.orderNo"
                />
              </div>
              <van-row class="font12 mt5">
                {{ $t('F002','预订时间') }}：{{ detail.bookDate }}
              </van-row>
              <van-row class="font12 mt5">
                {{ $t('F003','预订人') }}：{{ detail.bookerName }}
              </van-row>
              <van-notice-bar
                v-if="detail.isReject"
                class="clbz-bar"
                mode="link"
                :scrollable="false"
                @click="$dialog({title: $t('C452','拒单原因'), message: detail.errMsg})"
              >
                <span>{{ $t('C452','拒单原因') }}：{{ detail.errMsg }}</span>
              </van-notice-bar>
            </div>

            <div
              class="pad8"
              v-if="detail.orderNo"
            >
              <!-- 支付方式 -->
              <van-row
                v-if="detail.payMethodDesc"
                class="round-sm pad8 orange bg-lightYellow"
              >
                {{ detail.payMethodDesc }}
              </van-row>

              <!-- 经停信息 -->
              <div class="round-sm mt5 bg-white">
                <van-row
                  v-if="detail.takeTicketCode"
                  class="font12 pad8 gray"
                >
                  取票号：{{ detail.takeTicketCode }}
                </van-row>
                <stop-station
                  class="van-hairline--bottom"
                  :detail="detail"
                  train-no-class="main-color"
                />
                <van-row class="font12 pad8 text-center">
                  <router-link
                    to="/tr/OrderService"
                    class="main-color"
                  >
                    {{ $t('F010','退改签规则') }}
                  </router-link>
                </van-row>
              </div>

              <van-cell
                v-if="detail.trainAccount"
                class="round-sm mt5"
              >
                <span slot="title">
                  12306账号：
                  <span class="gray">{{ detail.trainAccount }}</span>
                </span>
                <ld-button
                  class="query-btn"
                  slot="right-icon"
                  size="sm"
                  @click.stop="showAccountValid = true"
                  round
                  main
                  style="width: 85px;"
                >
                  重新核验
                </ld-button>
              </van-cell>

              <!-- 乘车人列表 -->
              <van-cell-group class="mt5 round-sm">
                <psg-panel
                  v-for="(passenger, i) in detail.psgList"
                  :key="i"
                  :passenger="passenger"
                />
              </van-cell-group>

              <!-- 保险 -->
              <insurance
                class="mt5 round-sm"
                :cxrlength="detail.psgList.length"
                :order-id="detail.id"
                element=".trOrderDetail"
              />

              <relate-order :id="detail.id" />

              <!-- 优惠劵信息 -->
              <van-cell-group class="mt5 round-sm" v-if="yhjeList.length">
                <coupon-info :yhjeList="yhjeList" />
              </van-cell-group>

              <!-- 差旅信息 -->
              <travel-info
                class="mt5 round-sm"
                ref="travelinfo"
                :travel-data="detail"
                :details="true"
              />

              <!-- 审批规则 -->
              <approval
                class="mt5 round-sm"
                v-if="detail.showApprovalRule"
                :vip-status="detail.vipStatus"
                :order-id="id"
                :spgz-id="detail.appId"
                :isssbz="detail.isShowApproval!='1'"
              />

              <ld-uploader
                class="mt5 round-sm overflow"
                v-if="id"
                :order-id="id"
                :glywlx="'11009'"
                :cjlx="2"
                :order-status="detail.orderStatus"
              />
            </div>
            <!--  -->
            <van-row
              class="pad8 bg-lightColor"
              style="color: rgba(0, 0, 0, 0.6);"
            >
              温馨提示：若您的订单改签后需要退票，请前往退改签列表操作退票申请。
            </van-row>
          </div>
        </van-pull-refresh>
      </mescroll-vue>
    </div>


    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow pad-lr-10"
        type="flex"
        align="center"
        gutter="8"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col span="6">
          <div class="font10 gray">
            {{ $t('E017','共') }}{{ detail.psgList && detail.psgList.length }}人
          </div>
          <span class="font12 money-color">&yen;</span>
          <span class="font22 money-color"> {{ detail.totalAmount }}</span>
          <span
            class="font12 text-center"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
          </span>
        </van-col>
        <van-col span="18">
          <van-row
            type="flex"
            justify="end"
            gutter="8"
          >
            <van-col
              span="8"
              v-if="detail.isShowCancel == 1"
            >
              <ld-button
                defaults
                size="md"
                @click.stop="btnClick('cancel')"
              >
                {{ $t('B008','取消') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="detail.isShowCancelApproval==1"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('revertApproval')"
              >
                {{ $t('B065','撤回') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="detail.isShowChange == 1 && $store.state.tr.subsequent.trainchangeshow"
            >
              <ld-button
                defaults
                size="md"
                @click.stop="btnClick('change')"
              >
                {{ $t('B034','改签') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="detail.isShowRefund==1 && $store.state.tr.subsequent.trainrefundshow"
            >
              <ld-button
                defaults
                size="md"
                @click.stop="btnClick('refund')"
              >
                {{ $t('B035','退票') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="detail.isShowSs == 1"
            >
              <ld-button
                main
                size="md"
                @click.stop="btnClick('approval')"
              >
                {{ $t('B028','送审') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="detail.isShowSs == 2"
            >
              <ld-button
                main
                size="md"
                @click.stop="btnClick('approval')"
              >
                {{ $t('Submit','再送审') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="detail.isShowPay==1"
            >
              <ld-button
                main
                size="md"
                v-if="detail.isShowPay==1"
                @click.stop="pay"
              >
                {{ $t('B014','支付') }}
              </ld-button>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </ld-tabbar>


    <van-popup
      v-model="showAccountValid"
      position="bottom"
      closeable
      close-icon="close"
      round
      close-on-popstate
    >
      <ld-header>
        <span slot="left" />
        核验账号
      </ld-header>

      <van-cell-group>
        <van-field
          v-model="detail.trainAccount"
          disabled
          left-icon="contact"
          placeholder="请输入12306账号"
        />

        <van-field
          v-model="detail.password"
          type="password"
          placeholder="请输入12306密码"
        >
          <ld-icon
            slot="left-icon"
            type="iconpassword"
          />
        </van-field>
      </van-cell-group>

      <div class="pad8">
        <ld-button
          @click="validAccount"
          size="md"
          main
        >
          登录12306
        </ld-button>
      </div>
    </van-popup>

    <verificate
      ref="verificate"
      element=".trOrderDetail"
      :user-name="detail.trainAccount"
      :password="detail.password"
      :sms-check-msg="smsCheckMsg"
    />

    <face-detection
      ref="face-detection"
      element=".trOrderDetail"
      :user-name="detail.trainAccount"
      :password="detail.password"
    />
  </div>
</template>

<script>
import { CellGroup, Cell, PullRefresh, NoticeBar, Popup, Field } from 'vant'
import ldButton from 'Common/ldButton'
import travelInfo from 'Components/travelInfo'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import insurance from 'Components/insurance'
import ldEmailPopup from 'Components/LdEmailPopup'
import StopStation from '../trQuery/StopStation'
import approval from 'Components/approval/approval'
import PsgPanel from './PsgPanel'
import RelateOrder from './RelateOrder'
import handle from './handle'
import MescrollVue from 'mescroll.js/mescroll.vue'
import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'
import verificate from '../trQuery/trEdit/verificate12306.vue'
import faceDetection from '../trQuery/trEdit/face_detection12306.vue'
import ldUploader from 'Components/ldUploader'
import CouponInfo from './CouponInfo'


export default {
  provide: {
    orderType: $dict.ORDER_TYPE.tr.normal
  },
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    [NoticeBar.name]: NoticeBar,
    [Popup.name]: Popup,
    [Field.name]: Field,
    ldButton, travelInfo, ldTabbar, insurance, approval, StopStation,
    PsgPanel,
    RelateOrder,
    MescrollVue,
    verificate,
    faceDetection,
    ldUploader,
    ldEmailPopup,
    CouponInfo
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      detail: {}, // 正常单详情
      changeList: [],
      refundList: [],
      down:{ use: false },
      showAccountValid: false,
      smsCheckMsg: '',
      yhjeList: [], // 优惠劵列表
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    back () {
      this.$router.push({ path: '/allOrder?findType=1' })
    },
    async getDetail() {
      this.isLoading = true

      const { data } = await TrainOrderInteractor.getDetailById(this.id)

      this.isLoading = false
      this.detail = data
      if (this.detail && this.detail.yhje) {
        this.yhjeList = [{name: this.$t('E003', '优惠劵'), price: this.detail.yhje, amount: 1}]
      }
    },
    async btnClick (handleType) {
      if (handle[handleType]) {
        await handle[handleType](this.detail)
        this.getDetail()
      }
    },
    validAccount () {
      let params = {
        password: this.detail.password,
        userName: this.detail.trainAccount
      }

      this.$api['trQuery/12306Login'](params).then(res => {
        if (res.data == 1) {
          this.showAccountValid = false
          this.$toast({
            icon: 'passed',
            message: '核验成功'
          })
        } else {
          this.$dialog({ message: '登录失败！请核实后重新登录！' })
        }
      }).catch(err => {
        if (err.errCode == '239001') {
          this.$toast.clear()

          this.smsCheckMsg = err.tips
          this.$dialog.alert({
            title: '温馨提示',
            message: '根据铁路局规定，你的账号需要先完成短信核验。',
            confirmButtonText: '去核验',
          }).then(async () => {
            this.$refs['verificate'].toggle()
          })

        } else if (err.errCode == '239002') {
          this.$toast.clear()

          this.$refs['face-detection'].toggle()
        }
      })
    },
    pay () {
      // this.$refs.pay.toggle()
      this.$router.push({path:'/pay/payment',query:{orderType:this.detail.orderType,orderId:this.id}})
    }
  },
  computed: {
    priceList () {
      let rt = []
      if (this.detail.psgList) {
        let psgList = this.detail.psgList,
          adult = psgList.find(psg => psg.passengerType === '1'),
          child = psgList.find(psg => psg.passengerType === '2')


        rt = [
          { name: '总额', price: this.detail.totalAmount }
        ]

        if (adult) rt.push({ name: adult.passengerTypeName, price: adult.ticketPrice, amount: this.detail.adultCount, unit: '人' })
        if (child) rt.push({ name: child.passengerTypeName, price: child.ticketPrice, amount: this.detail.childCount, unit: '人' })
        if (this.detail.bxPrice) rt.push({ name: '保险', price: this.detail.bxPrice / psgList.length, amount: psgList.length, unit: '人' })
        rt.push({ name: '服务费', price: this.detail.sellServiceCharge / psgList.length, amount: psgList.length, unit: '人' })
        
        if(this.detail.yhje) {
          rt.push({name: this.$t('E003', '优惠劵'), price: this.detail.yhje, amount: 1})
        }
      }
      return rt
    },
  },
}
</script>

<style lang="less">
@import "~Assets/styles/business.less";

.trOrderDetail {
  .fontTitle{
    display: flex;
    justify-content:space-between;
    align-items:center;
    .dowPdf{
      font-size: 16px;
    }
  }
  .trOrderDetailWrapper {
    height: calc(100vh - 94px);
    overflow: hidden;
  }

  p {
    margin: 0;
  }

  .pad5 {
    padding: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .round-sm {
    overflow: hidden;
  }

  .StopStation {
    > .van-row {
      color: @color-text-black;
    }
  }
}
</style>
